import { render, staticRenderFns } from "./UserControllerDialog.vue?vue&type=template&id=84fdb710&scoped=true&"
import script from "./UserControllerDialog.vue?vue&type=script&lang=js&"
export * from "./UserControllerDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserControllerDialog.vue?vue&type=style&index=0&id=84fdb710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fdb710",
  null
  
)

export default component.exports